import isEmpty from 'lodash/isEmpty'
import isArray from 'lodash/isArray'
import { apolloProvider } from '@/apollo-provider.js'
import * as kpisServices from '@/services/kpis.js'
import * as productsServices from '@/services/products.js'
import * as costumersService from '@/services/costumers.js'
import * as segmentationServices from '@/services/segmentation.js'
import { MUTATION_SIGN_UP_CONFIRMATION_MANUALLY, MUTATION_RESEND_SIGN_UP_CONFIRMATION } from '../gerenciamento/graphql'

export default {
  async melhoresClientesTop({ state, commit }, filter) {
    const { data } = await kpisServices.melhoresClientes(filter)
    commit('SET_OBJECT', { name: 'melhoresClientes', data, state })
  },
  async listaInteressesPorGenero({ state, commit }, filter) {
    let { data } = await kpisServices.listaInteressesGenero(filter)
    if (!isArray(data)) {
      data = [data]
    }
    commit('SET_OBJECT', { name: 'listaInteressesGenero', data, state })
  },
  async listaInteressesPorIdade({ state, commit }, filter) {
    let { data } = await kpisServices.listaInteressesIdade(filter)
    if (!isArray(data)) {
      data = [data]
    }
    commit('SET_OBJECT', { name: 'listaInteressesIdade', data, state })
  },
  async listaInteressesPorIdadeValor({ state, commit }, filter) {
    let { data } = await kpisServices.listaInteressesIdadeValor(filter)
    if (!isArray(data)) {
      data = [data]
    }
    commit('SET_OBJECT', { name: 'listaInteressesIdadeValor', data, state })
  },
  async clientesTicketMedio({ state, commit }, filter) {
    const { data } = await kpisServices.ticketMedio(filter)
    commit('SET_OBJECT', { name: 'ticketMedio', data, state })
  },
  async clientesMediaItens({ state, commit }, filter) {
    const { data } = await kpisServices.mediaItens(filter)
    commit('SET_OBJECT', { name: 'mediaItens', data, state })
  },
  async clientesHorasMaioresCompras({ state, commit }, filter) {
    let { data } = await kpisServices.horasMaioresCompras(filter)
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'horasMaioresCompras', data, state })
  },
  async clientesDiasMaioresCompras({ state, commit }, filter) {
    let { data } = await kpisServices.diasMaioresCompras(filter)
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'diasMaioresCompras', data, state })
  },
  async clientesDiasSemanaMaioresCompras({ state, commit }, filter) {
    let { data } = await kpisServices.diasSemanaMaioresCompras(filter)
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'diasSemanaMaioresCompras', data, state })
  },
  async retencao({ state, commit }, filter) {
    let { data } = await kpisServices.retencao(filter)
    if (!Array.isArray(data.data)) data.data = [data.data]
    commit('SET_OBJECT', { name: 'retencao', data: data.data, state })
    commit('SET_OBJECT', { name: 'retencaoDatas', data: data.header, state })
  },
  async categoriasClientes({ state, commit }) {
    let { data } = await kpisServices.categoriasClientes()
    if (!Array.isArray(data)) data = [data]
    data.unshift({ COD_ID_CATEGORIA_CLIENTE: '', DES_CATEGORIA: 'Todos' })
    commit('SET_OBJECT', { name: 'categoriasClientes', data, state })
  },
  async perfilDemograficoBairroFisica({ state, commit }, filter) {
    let { data } = await kpisServices.clientesCadastrados({ ...filter, tipo_pessoa: 'F' })
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'perfilDemograficoBairroFisica', data, state })
  },
  async perfilDemograficoBairroJuridica({ state, commit }, filter) {
    let { data } = await kpisServices.clientesCadastrados({ ...filter, tipo_pessoa: 'J' })
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'perfilDemograficoBairroJuridica', data, state })
  },
  async perfilDemograficoCidadeFisica({ state, commit }, filter) {
    let { data } = await kpisServices.clientesCadastrados({ ...filter, tipo_pessoa: 'F' })
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'perfilDemograficoCidadeFisica', data, state })
  },
  async perfilDemograficoCidadeJuridica({ state, commit }, filter) {
    let { data } = await kpisServices.clientesCadastrados({ ...filter, tipo_pessoa: 'J' })
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'perfilDemograficoCidadeJuridica', data, state })
  },
  async perfilDemograficoFaixa({ state, commit }, filter) {
    let { data } = await kpisServices.clientesCadastrados(filter)
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'perfilDemograficoFaixa', data, state })
  },
  async perfilDemograficoGenero({ state, commit }, filter) {
    let { data } = await kpisServices.clientesCadastrados(filter)
    if (!Array.isArray(data)) data = [data]
    commit('SET_OBJECT', { name: 'perfilDemograficoGenero', data, state })
  },
  async quantidadeClientesCadastrados({ state, commit }) {
    const { data } = await kpisServices.clientesCadastrados({})
    commit('SET_OBJECT', { name: 'quantidadeClientesCadastrados', data: data['NUM_CLIENTES_CADASTRADOS'], state })
  },
  async validateProducts({ state, commit }, idList) {
    const data = await productsServices.searchProductList(idList)
    commit('SET_OBJECT', { name: 'produtosValidados', data, state })
    return data
  },
  async clientesInicioFidelidade({ state, commit }) {
    const { data } = await kpisServices.inicioFidelidade()
    commit('SET_OBJECT', { name: 'inicioFidelidade', data, state })
  },
  async clientesDatasLimites({ state, commit }) {
    if (!isEmpty(state.datasLimites)) return
    const { data } = await kpisServices.datasLimites({})
    commit('SET_OBJECT', { name: 'datasLimites', data, state })
    return data
  },
  async listaClientesPelaCompra({ state, commit }, filter) {
    const { data } = await kpisServices.listaClientesPelaCompra(filter)
    return data
  },
  async clientesClientesNovos({ state, commit }, filter) {
    const { data } = await kpisServices.clientesCadastrados(filter)
    commit('SET_OBJECT', { name: 'clientesNovos', data, state })
  },
  async clientesClientesAtivos({ state, commit }, filter) {
    const { data } = await kpisServices.clientesAtivos(filter)
    commit('SET_OBJECT', { name: 'clientesAtivos', data, state })
  },
  async clientesClientesPerdidos({ state, commit }, filter) {
    const { data } = await kpisServices.clientesPerdidos(filter)
    commit('SET_OBJECT', { name: 'clientesPerdidos', data, state })
  },
  async listagemClientesRetencaoAtivos({ state, commit }, filter) {
    const { data } = await kpisServices.listagemClientesRetencaoAtivos(filter)
    return data
  },
  async listagemClientesRetencaoInativos({ state, commit }, filter) {
    const { data } = await kpisServices.listagemClientesRetencaoInativos(filter)
    return data
  },
  async exportarListaClientes({ state, commit }, { filter, fileName }) {
    await segmentationServices.getSegmentationClients(filter, fileName)
  },
  async quantidadeClientesAtivos({ state, commit }, filter) {
    const { data } = await kpisServices.clientesAtivos(filter)
    commit('SET_OBJECT', { name: 'quantidadeClientesAtivos', data: data['NUM_CLIENTES_ATIVOS'], state })
  },
  async quantidadeClientesInativos({ state, commit }, filter) {
    const { data } = await kpisServices.clientesPerdidos(filter)
    commit('SET_OBJECT', { name: 'quantidadeClientesPerdidos', data: data['NUM_CLIENTES_PERDIDOS'], state })
  },
  async getHotsiteCustomers(_, filters) {
    const data = await costumersService.getHotsiteCustomers(filters)
    return data
  },
  signUpConfirmationManually(_, consumerId) {
    return new Promise((resolve, reject) => {
      apolloProvider.defaultClient
        .mutate({
          mutation: MUTATION_SIGN_UP_CONFIRMATION_MANUALLY,
          variables: {
            consumerId,
          },
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error))
    })
  },
  resendSignUpConfirmation(_, { userId, type }) {
    return new Promise((resolve, reject) => {
      apolloProvider.defaultClient
        .mutate({
          mutation: MUTATION_RESEND_SIGN_UP_CONFIRMATION,
          variables: {
            input: {
              userId,
              type,
            },
          },
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error))
    })
  },
}
